<template>
  <div
    class="w-full pt-[155px] text-[26px] leading-[36px] text-gray-800 font-secondary font-[370] text-center flex flex-col items-center px-6"
  >
    <div class="w-full max-w-[450px] flex flex-col flex-grow">
      <div class="max-w-[350px] tablet-v:w-full mx-auto">
        Help us understand your needs so we can
        <span class="text-green-700 font-semibold">
          best protect your work.
        </span>
      </div>

      <UiButton class="mt-auto w-full" primary large @click="handleClick">
        Next
      </UiButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { useOnboardingStore } from '@/features/onboarding/store'
import { UiButton } from '@dacr/ui'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const handleClick = () => {
  completeStep({
    step: 2,
  })

  onboardingStore.goToNextStep()
}
</script>
